import angular from 'angular';
import '../../core/data-access/billing-address.data-access';


(function() {
    'use strict';
    angular.module('app.principal').factory('BillingAddressSvc', BillingAddressSvc);

    BillingAddressSvc.$inject = ['BillingAddressDA'];

    /* @ngInject */
    function BillingAddressSvc(BillingAddressDA) {
        var exports = {

            getAllBillingAddress:getAllBillingAddress,
            saveBillingAddress:saveBillingAddress,
            getBillingAddress:getBillingAddress,
            updateBillingAddress:updateBillingAddress
        };

        return exports;

        function getAllBillingAddress(page = 0, size= 5,legalEntityId) {
            return BillingAddressDA.getAllBillingAddress(page,size,legalEntityId);
        }

        function saveBillingAddress(billingAddressDto,legalEntityId) {
            return BillingAddressDA.saveBillingAddress(billingAddressDto,legalEntityId);
        }
        function updateBillingAddress(billingAddressDto,legalEntityId) {
            return BillingAddressDA.updateBillingAddress(billingAddressDto,legalEntityId);
        }

        function getBillingAddress(billingAddressId){
            return BillingAddressDA.getBillingAddress(billingAddressId);

        }
    }
})();
